var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceAtom2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 345,
    viewBox: "0 0 343 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.148 276.276C265.904 260.689 249.613 201.549 208.759 144.184C167.906 86.8186 117.962 52.9505 97.2061 68.5376C76.4501 84.1247 92.7422 143.264 133.595 200.63C174.448 257.995 224.392 291.863 245.148 276.276Z",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.214 219.894C245.019 212.243 298.553 184.76 295.785 158.508C293.017 132.256 234.995 117.176 166.19 124.827C97.3845 132.477 43.8506 159.96 46.6186 186.212C49.3866 212.464 107.408 227.544 176.214 219.894Z",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.596 290.116C144.12 300.781 185.85 256.721 213.802 191.706C241.755 126.69 245.345 65.3387 221.821 54.6738C198.297 44.0089 156.567 88.0689 128.615 153.085C100.662 218.1 97.0723 279.451 120.596 290.116Z",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.335 188.381C172.932 192.279 182.979 188.282 186.775 179.453C190.571 170.624 186.678 160.307 178.08 156.409C169.483 152.511 159.436 156.508 155.64 165.337C151.844 174.166 155.737 184.483 164.335 188.381Z",
    fill: "#80FFAF",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceAtom2);
export default __webpack_public_path__ + "static/media/price-atom-2.0a5b537e118d50f97cb90f8d4261b0f6.svg";
export { ForwardRef as ReactComponent };